import { DataRoomNode } from 'router/subrouters/DataRoom/models/DataRoomNode';

export const getActivityNodeName = (node: Partial<DataRoomNode>) =>
  node?.isDeleted ? `${node?.name} - Deleted` : node?.name;
